// @flow

import { useContext } from 'react';

import { type PaymentMethod } from '../payment-method';
import { type SetSelectedPaymentMethod } from './types';

import { SelectedPaymentMethodContext } from './context';

export function useSelectedPaymentMethod(): [?PaymentMethod, SetSelectedPaymentMethod] {
  const tuple = useContext(SelectedPaymentMethodContext);
  if (!tuple) {
    throw new Error('SelectedPaymentMethodContext was not provided');
  }
  return tuple;
}
